<template>
  <div id="feedback" class="row" :style="{ height: pageHeight }" style="overflow-y: auto;">
    <br />
    <div style="margin: 40px 0;">
      <img
        src="/capsiminbox/images/CapsimInbox_Logo.png"
        height="85"
        class="center-block"
        alt="Capsim Inbox Text"
      />
    </div>
    <br />
    <div v-if="roleObj" class="col-md-10 col-md-offset-1">

      <div class="row mb-30" style="background-color: #003f54;">
        <h1 style="font-weight: 100; color: white" class="text-center mb-20">Thank you for completing the CapsimInbox demo experience!</h1>
      </div>

      <div class="row mb-30">
        <div class="col-md-8 col-md-offset-2">
          <img
            src="/capsiminbox/images/demo-preview.png"
            class="center-block"
            alt="CapsimInbox Demo"
          />
        </div>
      </div>

      <div class="row">
        <div class="col-md-12 text-center">
          <p v-html="roleObj.role"></p>
        </div>
      </div>
        
    </div>
  </div>
</template>
<script>

export default {

    name: "feedback",

    data: () => {
        return {
            windowHeight: 0
        }
    },

    computed: {
        roleObj() {
            return this.$store.state.role
        },
        pageHeight() {
            return `${this.windowHeight}px`
        },
    },

    created() {
        if( !this.$store.state.role ) this.$store.commit('SET_STATE')
    },

    mounted() {
       this.windowHeight = window.innerHeight
        this.$nextTick(() => {
            window.addEventListener('resize', () => {
                this.windowHeight = window.innerHeight
            });
        })
    }
}
</script>
